"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformNumberingTemplateToString = transformNumberingTemplateToString;
function transformNumberingTemplateToString(numberingTemplate, invoiceNumber) {
    return (`${numberingTemplate.prefix}${new Date().getFullYear()}` +
        `${invoiceNumber ? invoiceNumber.toString().padStart(numberingTemplate.digits, "0") : ""}`);
}
//# sourceMappingURL=transformNumberingTemplateToString.js.map